import { render, staticRenderFns } from "./VerifyConfirm.vue?vue&type=template&id=594a454f&scoped=true&"
import script from "./VerifyConfirm.vue?vue&type=script&lang=js&"
export * from "./VerifyConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594a454f",
  null
  
)

export default component.exports